import React from 'react';
import { ServicesContext } from '~/services';

export function useServiceSubscribe(event: null | string, fnc: Function) {
    // Context as ref removes it from effect dependencies
    const context = React.useRef<TODO_TYPEME>(null);
    context.current = React.useContext(ServicesContext);

    React.useEffect(() => {
        if (event) context.current.events.subscribe(event, fnc);
        return () => {
            if (event) context.current.events.unsubscribe(event, fnc);
        };
    }, [event, fnc]);
}
